(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/player-registration/assets/react/components/animated-columns.js') >= 0) return;  svs.modules.push('/modules/player-registration/assets/react/components/animated-columns.js');
'use strict';

const {
  ReactIcon: Icon
} = svs.ui;
const {
  Header
} = svs.playerRegistration.components;
const {
  FadeInSlideWrapper
} = svs.playerRegistration.components;


const animateShowHide = function () {
  let onComplete = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : () => {};
  const gsapElasticOut = top => ({
    top,
    duration: 2,
    ease: 'elastic.out'
  });
  const initTimeline = onComplete => gsap.timeline({
    onComplete,
    paused: true
  });
  const tl0 = initTimeline(onComplete);
  const tl1 = initTimeline(onComplete);
  const tl2 = initTimeline(onComplete);
  tl0.set('#player-registration-col-1', {
    top: '100%'
  });
  tl0.set('#player-registration-col-2', {
    top: '100%'
  });
  tl0.set('#player-registration-col-3', {
    top: '100%'
  });
  tl0.set('#player-registration-icon-1', {
    opacity: 0
  });
  tl0.set('#player-registration-icon-2', {
    opacity: 0
  });
  tl0.set('#player-registration-icon-3', {
    opacity: 0
  });
  tl0.to('#player-registration-col-1', gsapElasticOut('52%'));
  tl0.to('#player-registration-col-2', gsapElasticOut('43%'), '<');
  tl0.to('#player-registration-col-3', gsapElasticOut('34%'), '<');
  tl0.to('#player-registration-icon-1', {
    opacity: 1,
    duration: 1
  }, '-=1.5');
  tl0.to('#player-registration-icon-2', {
    opacity: 1,
    duration: 1
  }, '<');
  tl0.to('#player-registration-icon-3', {
    opacity: 1,
    duration: 1,
    backgroundColor: 'transparent'
  }, '<');
  tl1.set('#player-registration-col-1', {
    top: '52%'
  });
  tl1.set('#player-registration-col-2', {
    top: '43%'
  });
  tl1.set('#player-registration-col-3', {
    top: '34%'
  });
  tl1.set('#player-registration-icon-3', {
    backgroundColor: 'transparent'
  });
  tl1.to('#player-registration-icon-3', {
    backgroundColor: '#6218FF',
    duration: 0.10,
    ease: 'power2.out'
  }, '<');
  tl2.set('#player-registration-icon-3', {
    backgroundColor: 'transparent'
  });
  tl2.to('#player-registration-col-2', {
    border: '2px',
    top: 0,
    duration: 1,
    ease: 'power2.out'
  }, '<');
  return {
    forward: [() => {
      tl0.play(0);
    }, () => {
      tl0.progress(1);
      tl1.play(0);
    }, () => {
      tl1.progress(1);
      tl2.play(0);
    }],
    back: [() => {
      tl2.kill();
      tl1.reverse();
    }, () => {
      tl2.reverse();
    }]
  };
};
const ColumnWrapper = _ref => {
  let {
    children
  } = _ref;
  return React.createElement("div", {
    className: "u-flex u-flex-justify-content-center",
    style: {
      padding: 80
    }
  }, React.createElement("div", {
    className: "u-flex u-flex-justify-content-center u-border-bottom-4"
  }, children));
};
const ColumnFrame = _ref2 => {
  let {
    children
  } = _ref2;
  return React.createElement("div", {
    className: "u-border-2 margin-h-1 u-flex u-flex-column",
    style: {
      marginBottom: -2,
      borderRadius: '4.8px 4.8px 0 0',
      height: 200,
      width: 53,
      overflow: 'hidden',
      position: 'relative'
    }
  }, children);
};
const Column = _ref3 => {
  let {
    id,
    icon = 'checkmark'
  } = _ref3;
  return React.createElement("div", {
    className: "bg-navy",
    id: "player-registration-col-".concat(id),
    style: {
      width: '100%',
      height: '100%',
      top: '99%',
      position: 'absolute'
    }
  }, React.createElement("div", {
    className: "padding-v",
    id: "player-registration-icon-".concat(id)
  }, React.createElement("div", null, React.createElement(Icon, {
    color: "icon-inverted",
    icon: icon,
    size: 400
  }))));
};
const AnimatedColumns = () => {
  const [step, setStep] = React.useState(0);
  const [animation, setAnimation] = React.useState(null);
  React.useEffect(() => {
    const animation = animateShowHide(() => {}, () => {});
    setAnimation(animation);
    animation.forward[0]();
  }, []);
  const onBack = () => {
    setStep(step - 1);
    animation.back[step - 1]();
  };
  const onForward = () => {
    animation.forward[step + 1]();
    setStep(step + 1);
  };
  return React.createElement("div", {
    className: "f-center bg-tur-100"
  }, React.createElement(Header, null), React.createElement("div", {
    className: "u-center main-content-constrained"
  }, React.createElement("h1", {
    className: "h1"
  }, "Animated Columns"), React.createElement(ColumnWrapper, null, React.createElement(ColumnFrame, null, React.createElement(Column, {
    id: "1"
  })), React.createElement(ColumnFrame, null, React.createElement(Column, {
    icon: step === 2 ? 'exclamation-sign' : undefined,
    id: "2"
  })), React.createElement(ColumnFrame, null, React.createElement(Column, {
    icon: step === 1 ? 'clock-simple' : undefined,
    id: "3"
  }))), React.createElement("button", {
    disabled: step === 0,
    onClick: onBack,
    type: "button"
  }, "\u2190"), React.createElement("button", {
    disabled: step >= (animation === null || animation === void 0 ? void 0 : animation.forward.length) - 1,
    onClick: onForward,
    type: "button"
  }, "\u2192"), React.createElement(FadeInSlideWrapper, null, React.createElement("div", null, "FadeInSlideWrapper"), React.createElement("div", null, "ello"), React.createElement("div", null, "llo"), React.createElement("div", null, "lo"), React.createElement("div", null, "o"), React.createElement("div", null, "Hello"), React.createElement("div", null, "Hell"))));
};
svs.playerRegistration.components.AnimatedColumns = AnimatedColumns;

 })(window);